import { useEffect } from "react";
import { useDashboard } from "../../providers/dashboard";
import dayjs from "dayjs";

const InfoLine = ({ title, data }) => {
    return (
        <div
            className="flex justify-between text-sm"
        >
            <span>
                {
                    title
                }
            </span>
            <span>
                {data}
            </span>
        </div>
    )
}

const CarInfo = () => {
    const { state } = useDashboard();

    useEffect(() => {
        console.log(state.cars[state.selectedCar])
    }, [state])

    return (
        <div
            className="rounded-md shadow-md border-l-8 border-skgBlue px-4 divide-y bg-white"
        >
            <p
                className="text-xl py-4"
            >
                Bildata
            </p>
            <div
                className="py-4 space-y-2 font-light"
            >
                <InfoLine
                    title="Mærke"
                    data={state.cars[state.selectedCar].vehicle_make}
                />
                <InfoLine
                    title="Model"
                    data={state.cars[state.selectedCar].vehicle_model}
                />
                <InfoLine
                    title="Stelnummer"
                    data={state.cars[state.selectedCar].vin}
                />
                <InfoLine
                    title="Seneste reg.nr."
                    data={state.cars[state.selectedCar].plate}
                />
            </div>
        </div>
    )
}

export default CarInfo;